<template>
  <v-container fluid>
    <div class="report">
      <div class="header">
        <div class="s-title">年度财务汇总</div>
        <a-row class="staticlist">
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">年目标毛利</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(yeardata.v0, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">年收入</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(yeardata.v1, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">年成本</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(yeardata.v2, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">年实际毛利</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(yeardata.v3, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">年净利润</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(yeardata.v7, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">年完成率</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ yeardata.vr }} % </span>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <div class="s-title ">月度财务汇总</div>
        <a-row class="staticlist">
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">月目标毛利</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(monthdata.v0, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">月收入</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(monthdata.v1, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">月成本</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(monthdata.v2, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">月实际毛利</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(monthdata.v3, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
              </div>
              <div class="mc">
                <div class="ctitle">月净利润</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ $utils.formatMoney(monthdata.v7, 2, '') }} </span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="card">
              <div class="avatar">
                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
              </div>
              <div class="mc">
                <div class="ctitle">月完成率</div>
                <div class="cnum">
                  <a-icon v-if="loading" type="loading" />
                  <span v-else> {{ monthdata.vr }} % </span>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="list">
        <div class="s-title">月度财务报表明细</div>
        <div class="d-flex justify-space-between align-center">
          <v-tabs v-model="tab" bg-color="primary" class="mb-2" @change="getData">
            <v-tab v-for="item in tabs" :key="item.value">{{ item.text }}</v-tab>
          </v-tabs>
          <a-dropdown>
            <template #overlay>
              <a-menu @click="e => changeYear(e.key)">
                <template v-for="item in years">
                  <a-menu-item v-if="year !== item" :key="item">
                    {{ item }}
                  </a-menu-item>
                </template>
              </a-menu>
            </template>
            <a-button>
              <template v-for="item in years">
                {{ year === item ? item : '' }}
              </template>
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>
        <a-table class="tb_report" size="small" :columns="columns" :data-source="list" :loading="loading"
          :locale="{ emptyText: '暂无数据' }" style="width: 100%;" row-key="_id" :pagination="false">
          <template slot="fv0" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(0, record)">
              {{ record.fv0 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v0 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v0 < 0) || record.textClass === 'error--text'
            }">{{ record.fv0 + (record.v0p || '') }}</span>
          </template>
          <template slot="fv1" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(1, record)">
              {{ record.fv1 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v1 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v1 < 0) || record.textClass === 'error--text'
            }">{{ record.fv1 + (record.v1p || '') }}</span>
          </template>
          <template slot="fv2" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(2, record)">
              {{ record.fv2 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v2 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v2 < 0) || record.textClass === 'error--text'
            }">{{ record.fv2 + (record.v2p || '') }}</span>
          </template>
          <template slot="fv3" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(3, record)">
              {{ record.fv3 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v3 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v3 < 0) || record.textClass === 'error--text'
            }">{{ record.fv3 + (record.v3p || '') }}</span>
          </template>
          <template slot="fv4" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(4, record)">
              {{ record.fv4 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v4 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v4 < 0) || record.textClass === 'error--text'
            }">{{ record.fv4 + (record.v4p || '') }}</span>
          </template>
          <template slot="fv5" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(5, record)">
              {{ record.fv5 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v5 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v5 < 0) || record.textClass === 'error--text'
            }">{{ record.fv5 + (record.v5p || '') }}</span>
          </template>
          <template slot="fv6" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(6, record)">
              {{ record.fv6 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v6 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v6 < 0) || record.textClass === 'error--text'
            }">{{ record.fv6 + (record.v6p || '') }}</span>
          </template>
          <template slot="fv7" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(7, record)">
              {{ record.fv7 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v7 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v7 < 0) || record.textClass === 'error--text'
            }">{{ record.fv7 + (record.v7p || '') }}</span>
          </template>
          <template slot="fv8" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(8, record)">
              {{ record.fv8 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v8 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v8 < 0) || record.textClass === 'error--text'
            }">{{ record.fv8 + (record.v8p || '') }}</span>
          </template>
          <template slot="fv9" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(9, record)">
              {{ record.fv9 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v9 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v9 < 0) || record.textClass === 'error--text'
            }">{{ record.fv9 + (record.v9p || '') }}</span>
          </template>
          <template slot="fv10" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(10, record)">
              {{ record.fv10 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v10 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v10 < 0) || record.textClass === 'error--text'
            }">{{ record.fv10 + (record.v10p || '') }}</span>
          </template>
          <template slot="fv11" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(11, record)">
              {{ record.fv11 }}
            </a>
            <span v-else :class="{
              'success--text': (record.highlight && record.v11 > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.v11 < 0) || record.textClass === 'error--text'
            }">{{ record.fv11 + (record.v11p || '') }}</span>
          </template>
          <template slot="ftotal" slot-scope="text, record">
            <a v-if="record.showdetail" href="javascript:;" @click="showdetail('t', record)">
              {{ record.ftotal }}
            </a>
            <span v-else :class="{
              'font-weight-bold': true,
              'success--text': (record.highlight && record.total > 0) || record.textClass === 'success--text',
              'error--text': (record.highlight && record.total < 0) || record.textClass === 'error--text'
            }">{{ record.ftotal + (record.totalp || '') }}</span>
          </template>
        </a-table>
      </div>
    </div>
    <a-drawer :visible="dmodal" title="管理费用明细" @close="() => dmodal = false" placement="right" width="30%">
      <a-table size="small" :columns="dcolumns" :data-source="dlist" :loading="feeloading"
        :locale="{ emptyText: '暂无数据' }" style="width: 100%;" :pagination="false">
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="showfeedetail(record)">查看</a>
        </template>
      </a-table>
    </a-drawer>
    <a-modal :visible="drmodal" title="关联审批单" @cancel="() => drmodal = false" :footer="null" :width="750">
      <a-table size="small" :columns="drcolumns" :data-source="drlist" :scroll="{ y: 600 }"
        :locale="{ emptyText: '暂无数据' }" style="width: 100%;" :pagination="false">
        <template slot="businessId" slot-scope="text, record">
          <p>{{ record.businessId }}</p>
          <p>{{ record.title }}</p>
        </template>
        <template slot="expenseInfo" slot-scope="text, record">
          <p v-html="record.expenseInfo.replace(/\n/g, '<br>')"></p>
        </template>
      </a-table>
    </a-modal>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "Report",
  data() {
    return {
      year: this.$utils.dateFormat(new Date(), "YYYY"),
      years: [],
      tabs: [
        { value: "0", text: "项目汇总", },
        { value: "ergan", text: "二干项目", },
        { value: "ergan-section1", text: "二干一标段", },
        // { value: "ergan-section2", text: "二干二标段", },
        // { value: "ergan-section3", text: "二干三标段", },
        { value: "ergan-section4", text: "二干四标段", },
        // { value: "ergan-section5", text: "二干五标段", },
        // { value: "ergan-section6", text: "二干六标段", },
        { value: "yigan-yungui", text: "一干云贵线", },
        { value: "1", text: "恒都泌阳线", },
      ],
      columns: [
        { title: "科目", dataIndex: "project", scopedSlots: { customRender: "project" }, width: 100, align: "center", },
        { title: "一月", dataIndex: "fv0", scopedSlots: { customRender: "fv0" }, width: 100, align: "center" },
        { title: "二月", dataIndex: "fv1", scopedSlots: { customRender: "fv1" }, width: 100, align: "center" },
        { title: "三月", dataIndex: "fv2", scopedSlots: { customRender: "fv2" }, width: 100, align: "center" },
        { title: "四月", dataIndex: "fv3", scopedSlots: { customRender: "fv3" }, width: 100, align: "center" },
        { title: "五月", dataIndex: "fv4", scopedSlots: { customRender: "fv4" }, width: 100, align: "center" },
        { title: "六月", dataIndex: "fv5", scopedSlots: { customRender: "fv5" }, width: 100, align: "center", },
        { title: "七月", dataIndex: "fv6", scopedSlots: { customRender: "fv6" }, width: 100, align: "center", },
        { title: "八月", dataIndex: "fv7", scopedSlots: { customRender: "fv7" }, width: 100, align: "center" },
        { title: "九月", dataIndex: "fv8", scopedSlots: { customRender: "fv8" }, width: 100, align: "center" },
        { title: "十月", dataIndex: "fv9", scopedSlots: { customRender: "fv9" }, width: 100, align: "center", },
        { title: "十一月", dataIndex: "fv10", scopedSlots: { customRender: "fv10" }, width: 100, align: "center", },
        { title: "十二月", dataIndex: "fv11", scopedSlots: { customRender: "fv11" }, width: 100, align: "center", },
        { title: "合计", dataIndex: "ftotal", scopedSlots: { customRender: "ftotal" }, width: 120, align: "center", fixed: "right", }
      ],
      loading: false,
      list: [],
      yeardata: {
        v0: 0,
        v1: 0,
        v2: 0,
        v3: 0,
        v7: 0,
        vr: 0,
      },
      monthdata: {
        v0: 0,
        v1: 0,
        v2: 0,
        v3: 0,
        v7: 0,
        vr: 0,
      },
      height: 600,
      dmodal: false,
      dlist: [],
      dmonth: '',
      dtotal: {
        label: "合计",
        value: "",
      },
      dcolumns: [
        { title: "项目", dataIndex: "label", scopedSlots: { customRender: "label" }, width: 120, align: "center", },
        { title: "费用", dataIndex: "value", scopedSlots: { customRender: "value" }, width: 120, align: "center" },
        { title: "关联审批", dataIndex: "operation", scopedSlots: { customRender: "operation" }, width: 120, align: "center" },
      ],
      drlist: [],
      drcolumns: [
        { title: "审批单", dataIndex: "businessId", scopedSlots: { customRender: "businessId" }, width: 240 },
        { title: "事由", dataIndex: "expenseInfo", scopedSlots: { customRender: "expenseInfo" }, },
        { title: "金额", dataIndex: "fee", scopedSlots: { customRender: "fee" }, width: 120 },
      ],
      drmodal: false,
      feeloading: false,
      tab: 0,
    }
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  mounted() {

  },
  activated() {
    this.getData();
  },
  methods: {
    changeYear(v) {
      this.year = v;
      this.getData();
    },
    getData() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/caiwu_report/list", { tab: this.tabs[this.tab].value, year: this.year }).then((res) => {
        this.tabs = res.data.tabs;
        this.years = res.data.years;
        if (this.tab === 0) {
          this.yeardata = res.data.yeardata;
          this.monthdata = res.data.monthdata;
        }
        this.list = res.data.list.map(n => {
          return {
            ...n,
            highlight: n.project === '项目毛利' || n.project === '项目净利润' || n.project === '毛利率',
            textClass: n.project === '业务收入' ? 'success--text' : (n.project === '业务成本' || n.project === '资金成本') ? 'error--text' : '',
            showdetail: n.project === '管理费用',
            fv0: this.$utils.formatMoney(n.v0, 2, ''),
            fv1: this.$utils.formatMoney(n.v1, 2, ''),
            fv2: this.$utils.formatMoney(n.v2, 2, ''),
            fv3: this.$utils.formatMoney(n.v3, 2, ''),
            fv4: this.$utils.formatMoney(n.v4, 2, ''),
            fv5: this.$utils.formatMoney(n.v5, 2, ''),
            fv6: this.$utils.formatMoney(n.v6, 2, ''),
            fv7: this.$utils.formatMoney(n.v7, 2, ''),
            fv8: this.$utils.formatMoney(n.v8, 2, ''),
            fv9: this.$utils.formatMoney(n.v9, 2, ''),
            fv10: this.$utils.formatMoney(n.v10, 2, ''),
            fv11: this.$utils.formatMoney(n.v11, 2, ''),
            ftotal: this.$utils.formatMoney(n.total, 2, ''),
          }
        });
        this.$toast.clear();
      });
    },
    showdetail(i, item) {
      if (item[`v${i}list`].length === 0) return;
      let total = this.$utils.d();
      this.dlist = item[`v${i}list`].map(n => {
        total = total.plus(n.value);
        return {
          value: this.$utils.formatMoney(n.value, 2, ''),
          label: n.label,
        };
      });
      this.dmonth = item[`v${i}m`];
      this.dtotal.value = this.$utils.formatMoney(total, 2, '');
      this.dmodal = true;
    },
    showfeedetail(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/caiwu_report/feedetail", { month: this.dmonth, label: item.label, tab: this.tabs[this.tab].value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.drlist = res.data.result;
          this.drmodal = true;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    }
  },
};

</script>
<style lang="less" scoped>
.report {
  .s-title {
    font-size: 24px;
    padding: 0 0 10px 0;
  }

  .staticlist {

    background: #fff;
    margin-bottom: 10px;

    .card {
      display: flex;

      .mc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;

        .ctitle {
          font-size: 20px;
        }

        .cnum {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  }
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
